import { defineStore } from "pinia";

interface State {
  historyGame: string[];
  scrollX: number;
  isShowBuyGoodModal: boolean;
  buyGoodModalGoodsId: number;
  buyGoodModalGoodsKind: number;
  isBuyGoodSuccess: boolean;
  searchKeyWord: string;
  isShowChangeVipModal: boolean;
  buyGoodModalGameId: number;
  clientSecret: string;
  tradeNo: string;
  currency: string;
}

export const useGameListStore = defineStore("gameList", {
  state: (): State => ({
    historyGame: [], // 最近玩过游戏
    scrollX: 0,
    // 购买游戏弹窗
    isShowBuyGoodModal: false,
    // 用于请求的商品id
    buyGoodModalGoodsId: 0,
    // 用于请求的商品id 时的种类
    buyGoodModalGoodsKind: 0,
    // 是否购买游戏成功
    isBuyGoodSuccess: false,
    // 用于搜索游戏库的关键字
    searchKeyWord: "",
    isShowChangeVipModal: false,
    buyGoodModalGameId: 0,
    clientSecret: "",
    tradeNo: "",
    currency: "",
  }),
  actions: {
    setup() {
      const gameListStore = useGameListStore();
      window.addEventListener("scroll", () => {
        gameListStore.changeScrollX(window.scrollX || window.pageXOffset);
      });
    },
    async changeHistoryGame(payload: string[]) {
      this.historyGame = payload;
    },

    changeScrollX(payload: number) {
      this.scrollX = payload;
    },
    updateStateProp(key: string, keyValue: any) {
      this[key] = keyValue;
    },
    updateGoogleAirWallexPayData(payload: {
      clientSecret: string;
      tradeNo: string;
      currency: string;
    }) {
      this.clientSecret = payload.clientSecret;
      this.tradeNo = payload.tradeNo;
      this.currency = payload.currency;
    },

    update_isShowBuyGoodModal(payload: any) {
      this.buyGoodModalGoodsId = payload.goodsId;
      this.buyGoodModalGoodsKind = payload.kind;
      this.isShowBuyGoodModal = payload.isShow;
      this.buyGoodModalGameId = payload.gameId;
    },
    update_isBuyGoodSuccess(payload: boolean) {
      this.isBuyGoodSuccess = payload;
    },
    update_searchKeyWord(payload: string) {
      this.searchKeyWord = payload;
    },
    update_isShowChangeVipModal(payload: any) {
      this.isShowChangeVipModal = payload.isShow;
    },
  },
});
